import { render, staticRenderFns } from "../templates/normal_fcont_162.html?vue&type=template&id=04c1188d&scoped=true&"
import script from "./normal_fcont_162.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_162.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1188d",
  null
  
)

export default component.exports